import { formatBrDate } from "../../../infra/helpers/date";

interface TableProps {
  dataInfo: any,
  columns: any
}

export function Table({dataInfo, columns } : TableProps) {
  return (
    <div className="py-2 w-full">
      <table className="w-full flex flex-col text-[.75rem]" id="tabelaImpressao">
        <thead className="border-b">
          <tr className="items-center border-b">
            {
              columns?.filter((except : any) => except.title !== 'Observações' && except)
              .map((col : any) => {
                return <>
                  <th id={`${col.dataIndex}`} className={`md:w-[${col.width}rem] w-[${col.width}rem] text-start`}>{col.title}</th>
                </>
              })
            }
          </tr>
        </thead>
        <tbody className="text-[.7rem]">
          {
            dataInfo?.map((rows : any, index : number) => {
              return <>
                <tr className="flex items-center border-b">
                  <td className="text-start md:w-[8.1rem] w-[8rem]">{formatBrDate(rows.DataMovimento)}</td>
                  <td className="text-start md:w-[8rem] w-[10rem]">{rows.MovimentoTipo}</td>
                  <td className="text-start md:w-[8rem] w-[12rem]">{rows.MovimentoCodigoReferencia}</td>
                  <td className="text-start md:w-[8rem] w-[8.9rem]">{rows.TouroRack}</td>
                  <td className="text-start md:w-[38rem] w-[30.7rem]">{rows.ProdutoNome}</td>
                  <td className="text-start md:w-[8rem] w-[9rem]">{rows.TouroRaca}</td>
                  <td className="text-start md:w-[8rem] w-[9rem]">{rows.TouroSemenTipo}</td>
                  <td className="text-start md:w-[8rem] w-[9rem] text-end">{rows.Quantidade}</td>
                </tr>
                <tr className="h-[1.5rem]"><td>Observação: {rows.Observacoes}</td></tr>
                <hr/>
              </>
            })
          }
        </tbody>
      </table>
    </div>
  );
}